<template>
  <a-card title="VIP 管理">
    <a-form :label-col="{ span:3 }" :model="formAdd"  style="margin: 10px auto;" :rules="rules" ref="formRef" >
      <a-form-item  label="区号" name="country_code">
        <a-input :allowClear=true placeholder="区号" v-model:value="formAdd.country_code" />
      </a-form-item>
      <a-form-item label="手机号" name="phone">
        <a-textarea :allowClear=true :rows="4" placeholder="手机号，换行符分割" v-model:value="formAdd.phone" />
        (支持批量，换行分割，总数: {{ inputPhones.length }})
      </a-form-item>
        <a-form-item label="外显ID" name="outer_ids">
        <a-textarea :allowClear=true :rows="4" placeholder="外显 ID，换行符分割" v-model:value="formAdd.outer_ids" />
        (支持批量，换行分割，总数: {{ inputOuterIDs.length }})
      </a-form-item>
      <a-form-item label="UserID" name="user_id">
        <a-input placeholder="用户 ID" v-model:value="formAdd.user_id" />
        <a-alert message="手机、外显ID、用户 ID 三选一，手机号 > 外显 ID > 用户 ID" type="warning"></a-alert>
      </a-form-item>
      <a-form-item label="是否是内部用户:" name="is_internal">
        <a-radio-group v-model:value="formAdd.is_internal">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
        <a-alert message="开会员和加油包均生效，如果批量开通，则对批量用户生效，实习生均认为是内部用户" type="info"></a-alert>
      </a-form-item>
      
      <a-divider />
      <div style="margin: 10px;">
      <a-alert message="以下两个套餐，选哪个就给发哪个。都选都发。" type="info" show-icon  />
      </div>
      <a-form-item :allowClear=true  label="会员套餐"  name="meal_id">
        <div style="display: flex;flex-direction: row;">
          <div style="display: flex;flex-direction: column;">
            <a-select
              :allowClear="true"
              v-model:value="formAdd.meal_id"
              :options="mealOptions"
              placeholder="套餐"
            />
            <p style="color: red;">*实际购买成功的用户只能填写套餐，不要填写天数</p>
            <a-alert message="填写正确的套餐有助于后续的权益判断，尽量使用套餐而非天数。选择套餐后会优先使用套餐。" type="warning"></a-alert>
            <div style="margin-top:4px;" >
                <a-form-item :allowClear=true  label="会员策略"  name="vip_tier_type">
                <a-select 
                  style="width: 200px;"
                  :allowClear="true"
                  v-model:value="formAdd.vip_tier_type"
                  :options="vipTierTypeOptions"
                  placeholder="策略 ID"
                />
              </a-form-item>
            </div>
          </div>
          <div style="margin-left: 10px;">
              <a-form-item :allowClear=true  label="指定天数"  name="days">
              <a-select 
                style="width: 100px;"
                :allowClear="true"
                v-model:value="formAdd.days"
                :options="productOptions"
                placeholder="天数"
              />
            </a-form-item>  
          </div>
        </div>
      </a-form-item>
        <a-form-item :allowClear=true  label="加量包套餐"  name="score_meal_id">
        <a-select
          :allowClear="true"
          v-model:value="formAdd.score_meal_id"
          :options="scorePackMealOptions"
          placeholder="加量包套餐"
        />
      </a-form-item>
      <a-form-item :allowClear=true  label="加油包有效天数"  name="fuel_score_days">
        <a-select
          v-model:value="formAdd.fuel_score_days"
          :options="fuelScoreDaysOptions"
          placeholder="加油包有效天数"
        />
      </a-form-item>
      <a-divider />

      <a-form-item label="苹果订单号">
        <a-input-search
          v-model:value="appleOrderNo"
          placeholder="苹果订单号"
          enter-button="查询苹果订单信息"
          :loading="appleQueryLoading"
          allow-clear
          @search="lookupAppleOrder"
        />
        <a-alert message="订单号在支付宝、苹果收据邮件中均有体现" type="warning"></a-alert>
      </a-form-item>

      <a-form-item label="原始交易 ID" name="origin_transaction_id">
        <a-input :allowClear=true placeholder="Origin Transaction ID" v-model:value="formAdd.origin_transaction_id" />
        <a-alert message="填写通过苹果订单号查到 Origin Transaction ID，填写此项将支持「自动续费」到当前账号" type="warning"></a-alert>
      </a-form-item>
      <a-form-item label="交易 ID" name="transaction_id">
        <a-input :allowClear=true placeholder="交易 ID" v-model:value="formAdd.transaction_id" />
        <a-alert message="填写通过苹果订单号查到 Transaction ID" type="warning"></a-alert>
      </a-form-item>
        <a-divider />
      <a-form-item required label="开通说明" name="remark">
        <a-input :allowClear=true placeholder="开通说明" v-model:value="formAdd.remark" />
      </a-form-item>
      <a-form-item >
        <a-button  
          style="float:right;"
          :loading="confirmLoading"
          type="primary"
          @click="() => handleConfirm()"
          >立即开通</a-button>
      </a-form-item>
    </a-form>
  </a-card>
  <a-modal width="60%" title="会员开通成功" v-model:visible="resultVisible"  @cancel="resetForm" @ok="resultVisible=false" >
    <div v-for="item in result" :key="item.user_id">
       <a-row v-if="item.is_exist">
        <a-col :span="4">
           UID: {{ item.user_id }}<br />
           手机: {{ item.mobile }}
           <a-tag color="green">操作成功</a-tag>
        </a-col>
         <a-col  :span="4">
           昵称: {{ item.nickname }}
        </a-col>
          <a-col  :span="6">
           订阅类型: {{ item.vip_meal_name + `(${item.vip_meal_id})` }} <br/>
          策略: {{ TierTypeMap[item.vip_tier_type] }}
        </a-col>
         <a-col  :span="7">
           开始时间: {{ new Date(item.started_at).toLocaleString() }} <br/>
           过期时间: {{ new Date(item.expired_at).toLocaleString() }}
        </a-col>
       </a-row>
       <a-row v-else>
        <a-col :span="8">
          手机: {{ item.mobile }}
          <a-tag color="red">用户不存在</a-tag>
        </a-col>
       </a-row>
       <a-divider />
      </div>
  </a-modal>
</template>
<script>
import { defineComponent,  onMounted} from 'vue'
// import UserEditor from '@/components/UserEditor.vue'
import axios from 'axios'
import { message } from 'ant-design-vue';
import request from '@/utils/request'
import { Modal } from 'ant-design-vue';
import { useStore } from 'vuex'

const defaultVIPRecord = {
  phone: '',
  outer_ids: '',
  vip_tier_type: "2",
  country_code: "+86",
  user_id: '',
  days: '',
  meal_id: '',
  score_meal_id: '',
  fuel_score_days: 7,
  is_internal: null,
  transaction_id: '',
  origin_transaction_id: '',
  remark: ''
}
const TierTypeMap = {
  // "1": "老策略（每天100次）",
  "2": "新策略（每月100次）",
}
const vipTierTypeOptions = [
      // {
      //   label:TierTypeMap["1"],
      //   value: "1",
      // },
      {
        label:TierTypeMap["2"],
        value: "2",
      },]


export default defineComponent({
  components: {
  },
  data(){
    return {
      TierTypeMap,
    vipTierTypeOptions: vipTierTypeOptions,
    scorePackMealOptions: [
      {
        label: "100次 38元", value: "200",
      },
      {
        label: "500次 168元", value: "210",
      },
      {
        label: "1000次 268元", value: "220",
      },
      // {
      //   label: "20次 9.9元", value: "230",
      // }, 
    ],
    fuelScoreDaysOptions: [
      { label: "一周 7天", value: 7 },
      { label: "半个月 15天", value: 15 },
      { label: "一个月 30天", value: 30 },
      { label: "半年 180天", value: 180 },
    ],
    mealOptions: [
      {
        label: "周会员 Weekly", value: "5",
      },
      {
        label: "月会员 Monthly", value: "8",
      },
      {
        label: "半年会员 6Month", value: "7",
      },
      {
        label: "年会员 1Year", value: "6",
      }, 
      {
        label: "终生会员", value: "100000",
      }, {
        label: "海外周会员 freetrial_weekly", value: "100",
      },
      {
        label: "海外年会员 freetrial_yearly", value: "110",
      },
    ],
      productOptions: [
        {
          label:"无",
          value: "",
        },
        {
          label:"1天",
          value: "1",
        },
        {
          label:"2天",
          value: "2",
        },
        {
          label:"3天",
          value: "3",
        },
        {
          label:"4天",
          value: "4",
        },
        {
          label:"5天",
          value: "5",
        },
        {
          label:"6天",
          value: "6",
        },
        {
          label:"7天",
          value: "7",
        },
        {
          label:"10天",
          value: "10",
        },
        {
          label:"1个月",
          value: "30",
        },
        {
          label:"3.5个月",
          value: "108",
        },
        {
          label:"6个月",
          value: "180",
        },
        {
          label:"12个月",
          value: "365",
        }, {
          label:"终身",
          value: "18250", // 50 * 365
        }
      ],
      loading: false,
      openDia: false,
      dataSource: [],
      formAdd: {
        ...defaultVIPRecord
      },
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',

       formSearch: {
        query: ''
      },
      resultVisible: false,
      result: {},
      confirmLoading: false,
      uploadLoading: false,
      appleOrderNo: '',
      appleQueryLoading: false,
    }
  },
  mounted(){
    // this.resetForm()
  },
  computed:{
    inputOuterIDs: function(){
      if (!this.formAdd.outer_ids) {
        return []
      }
      return this.formAdd.outer_ids.split("\n")
    },
    inputPhones : function(){
      if (!this.formAdd.phone) {
        return []
      }
      return this.formAdd.phone.split("\n")
    },
  },
  methods: {
    async lookupAppleOrder() {
      if (!this.appleOrderNo.trim()) return
      this.appleQueryLoading = true
      try {
        const rsp = await axios.get('/api/orders/lookup_no', { params: { order_no: this.appleOrderNo.trim() } })
        if (rsp.data.code !== 0) {
          message.warning(rsp.data.message || '查询失败')
          return
        }
        const { originalTransactionId, transactionId } = rsp.data.data
        if (originalTransactionId) this.formAdd.origin_transaction_id = originalTransactionId
        if (transactionId) this.formAdd.transaction_id = transactionId
      } catch (err) {
        const msg = err?.response?.data?.message || err?.message || '查询失败'
        message.warning(msg)
      } finally {
        this.appleQueryLoading = false
      }
    },
    async handleConfirm(){
      this.formAdd.phone = this.formAdd.phone.trim()
      this.formAdd.user_id = this.formAdd.user_id.trim()
      this.formAdd.country_code = this.formAdd.country_code.trim()
      if (!this.formAdd.phone && !this.formAdd.user_id && !this.formAdd.outer_ids) {
        Modal.warning({
          title: '提示',
          content: '请输入手机号或用户 ID或外显 ID',
        });
        return
      }
      if (!this.formAdd.days && !this.formAdd.meal_id && !this.formAdd.score_meal_id) {
        Modal.warning({
          title: '提示',
          content: '请选择天数或套餐',
        });
        return
      }
      if (!this.formAdd.remark) {
        Modal.warning({
          title: '提示',
          content: '请输入开通说明',
        });
        return
      }
      if (this.formAdd.is_internal === null) {
        Modal.warning({
          title: '提示',
          content: '请选择是否是内部用户',
        });
        return
      }
      this.confirmLoading = true
      try {
        if (this.formAdd.meal_id || this.formAdd.days) {
          const rsp = await request.post('/api/vips/grant/vip', {
            ...this.formAdd,
            vip_tier_type: +this.formAdd.vip_tier_type,
            days: +this.formAdd.days,
            fuel_score_days: +this.formAdd.fuel_score_days,
            is_internal: +this.formAdd.is_internal,
          }, "")
          this.result = rsp.data.result
          this.resultVisible = true
        }
        if (this.formAdd.score_meal_id){
          const rsp = await request.post('/api/vips/grant/score_pack', {
            ...this.formAdd,
            days: +this.formAdd.days,
            fuel_score_days: +this.formAdd.fuel_score_days,
            is_internal: +this.formAdd.is_internal,
          })
        }
      } catch(e) {
        console.log(e)
      }
     
      this.confirmLoading = false
      this.$refs.formRef.resetFields();

    },
    resetForm() {
      this.$refs.formRef.resetFields();
    },
   
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
    }
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
</style>